import { UserAgent } from './user-agent';
import { LocalStorage, QueueStorage } from './local-storage';

export {
  UserAgent,
  LocalStorage,
  QueueStorage
};
